import React, {} from 'react';
import { filterTagStyles } from './FilterTag.styles';
export const FilterTag = ({ children, label, size }) => (React.createElement("div", { className: filterTagStyles({ size }) },
    React.createElement("span", { className: "font-medium whitespace-nowrap" }, label),
    children));
